exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n**  Style override for the default Zendesk display\n*/\n\n#webWidget {\n  bottom: 0 !important;\n  left: 55px !important;\n}\n", ""]);

// exports
